import React, {Component} from 'react';
import {connect} from "react-redux";
import {changeHead} from "../../../../Structure/actions/actionsStructure";
import {checkIsLogin} from "../../../../AdminProtectora/actions/actionsAdmin";
import {LazyLoadImage} from "react-lazy-load-image-component";

class HeadMenuLogin extends Component {
    constructor(props) {
        super(props);
    }


    /* Set the width of the side navigation to 250px and the left margin of the page content to 250px and add a black background color to body */
    // openNav() {
    //    document.getElementById("mySidenav").style.width = "250px";
    //    document.getElementById("page-login").style.marginLeft = "250px";
    //    document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
    // }
    //
    // /* Set the width of the side navigation to 0 and the left margin of the page content to 0, and the background color of body to white */
    //  closeNav() {
    //     document.getElementById("mySidenav").style.width = "0";
    //     document.getElementById("page-login").style.marginLeft = "0";
    //     document.body.style.backgroundColor = "white";
    // }

    render() {

        const url_imagen = (this.props.access && this.props.access.data && this.props.access.data.img_principal && this.props.access.data.img_principal.url) ? this.props.access.data.img_principal.url : undefined

        return (
            <div className="nav-bar-menu-login">

                <div id="sidenav-left-login" className="sidenav">
                    <a href="" className="closebtn-sidenav"
                       onClick={this.props.onCloseNav}>&times;</a>
                    <div className="profile">
                        <div className="profile-img">
                            <LazyLoadImage threshold={150}
                                src={(url_imagen) ? url_imagen : process.env.CDN_URL+'/images/adoptaunanimal/default/protectora2.png'}
                                alt="profile_picture"/>
                        </div>
                        <p>{this.props.access.user}</p>
                    </div>
                    {/*<a href="javascript:void(0)" className="openbtn-sidenav" onClick={this.openNav}><span className="las la-bars"/></a>*/}
                    {/*<a onClick={this.props.onOpenNav} href="#" type="button"*/}
                    {/*   className="btn btn-outline-secondary dropdown-item openbtn-sidenav" aria-label="Left Align">*/}
                    {/*    <span className="las la-lg la-bars" aria-hidden="true"/>{' '}*/}
                    {/*</a>*/}
                    {/*<ul>*/}
                    {/*<li>*/}
                    {/*    <b></b>*/}
                    {/*    <b></b>*/}
                    <a onClick={this.props.hall} href="#" type="button"
                       className="btn btn-outline-secondary dropdown-item" aria-label="Left Align">
                        <span className="las la-lg la-home" aria-hidden="true"/>{' '} Panel
                    </a>
                    {/*</li>*/}
                    <hr/>

                    <p className="" aria-label="Left Align">ADMINISTRACIÓN</p>
                    {/*<li>*/}
                    {/*    <b></b>*/}
                    {/*    <b></b>*/}
                    <a onClick={this.props.goAnimalNuevo} href="#" type="button"
                       className="btn btn-outline-secondary dropdown-item" aria-label="Left Align">
                        <span className="las la-lg la-plus" aria-hidden="true"/>{' '} Añadir animal
                    </a>

                    {/*</li>*/}
                    {/*<li>*/}
                    {/*    <b></b>*/}
                    {/*    <b></b>*/}
                    <a onClick={this.props.goAdminAnimals} href="#" type="button"
                       className="btn btn-outline-secondary dropdown-item" aria-label="Left Align">
                        <span className="las la-lg la-paw" aria-hidden="true"/>{' '} Administrar animales
                    </a>
                    {/*</li>*/}

                    <hr/>
                    <p className="" aria-label="Left Align">CONFIGURACIÓN</p>
                    {/*<li>*/}
                    {/*    <b></b>*/}
                    {/*    <b></b>*/}
                    <a onClick={this.props.goPerfil} href="#" type="button"
                       className="btn btn-outline-secondary dropdown-item" aria-label="Left Align">
                        <span className="las la-lg la-user" aria-hidden="true"/>{' '} Perfil
                    </a>
                    {/*</li>*/}

                    <hr/>
                    {/*<p className="" aria-label="Left Align">GANA PIENSO</p>*/}
                    {/*<a onClick={this.props.hall} href="#" type="button"*/}
                    {/*   className="btn btn-outline-secondary dropdown-item" aria-label="Left Align">*/}
                    {/*    <span className="las la-lg la-dollar-sign" aria-hidden="true"/>{' '} Recomiéndanos*/}
                    {/*</a>*/}
                    {/*<hr/>*/}
                    <p className="" aria-label="Left Align">SERVICIOS</p>
                    {/*<li>*/}
                    {/*    <b></b>*/}
                    {/*    <b></b>*/}
                    <a onClick={this.props.goServicios} href="#" type="button"
                       className="btn btn-outline-secondary dropdown-item" aria-label="Left Align">
                                <span className="las la-lg la-address-card notify-container" aria-hidden="true">
                                    <span className="notify-bubble">{' '}</span>
                                </span>
                        {' '} Servicios
                    </a>
                    {/*</li>*/}

                    <hr/>

                    <p className="" aria-label="Left Align"></p>
                    {/*<li>*/}
                    {/*    <b></b>*/}
                    {/*    <b></b>*/}
                    {/*<p   className="" aria-label="Left Align">SOPORTE</p>*/}
                    <a onClick={this.props.contact} href="#" type="button"
                       className="btn btn-outline-secondary dropdown-item" aria-label="Left Align">
                        <span className="las la-lg la-comment" /*aria-hidden="true"*/></span> Contactar con
                        soporte
                    </a>
                    {/*</li>*/}

                    {/*<li>*/}
                    {/*    <b></b>*/}
                    {/*    <b></b>*/}
                    {/*<hr/>*/}
                    <a onClick={this.props.logout} href="#" type="button"
                       className="btn btn-outline-secondary dropdown-item" aria-label="Left Align">
                        <span className="las la-lg la-sign-out-alt" aria-hidden="true"/>{' '}
                        Cerrar sesión
                    </a>
                    {/*</li>*/}

                    {/*</ul>*/}

                </div>
            </div>
        );
    }


    componentDidMount() {

        // **** cambiar esto si está el sidenav cerrado
        const that = this;
        $(document).mouseup(function (e) {
            const container = $('.sidenav');

            // if the target of the click isn't the container nor a descendant of the container
            if (!container.is(e.target) && container.has(e.target).length === 0) {

                if ($(window).width() < 992) {
                    that.props.onCloseNav()
                }
            }
        });


        // const list = $('#sidenav-left-login ul li')
        // for (let i = 0; i < list.length; i++) {
        //     list[i].onclick = (e) => {
        //         $(this).toggleClass('active')
        //     }
        // }

    }
}


function mapStateToProps(state) {
    return {
        showHead: state.structureControl.showHead,
        access: state.access,
        animalDetailProtectora: state.animalDetailProtectora,
    };
}

export default connect(mapStateToProps, {changeHead, checkIsLogin})(HeadMenuLogin);
